module.exports = __webpack_public_path__ + "static/images/four.36kY7GY.svg";